import { AlertTriangle, Ban, KeyRound } from "lucide-react";
import { usdFine as usd } from "./useAiEdits";

export function BudgetWarning({ budget: b, testid = "budget-warning" }) {
  if (!b?.warn) return null;
  const parts = [];
  if (b.month_pct != null && b.month_pct >= b.warn_pct) parts.push(`budget mensile al ${b.month_pct}% (${usd(b.month_spent)} di ${usd(b.month_budget)})`);
  if (b.project_pct != null && b.project_pct >= b.warn_pct) parts.push(`budget del progetto al ${b.project_pct}% (${usd(b.project_spent)} di ${usd(b.project_budget)})`);
  return (
    <p className="flex items-start gap-1 text-[11px] leading-snug text-amber-700" data-testid={testid}>
      <AlertTriangle size={12} className="mt-px shrink-0" />Attenzione: {parts.join(" · ")}
    </p>
  );
}

export const calibrationText = (c) => (!c ? "" : c.calibrated ? `Stima tarata su ${c.samples} operazioni reali (${c.basis})` : c.basis.charAt(0).toUpperCase() + c.basis.slice(1));

// Source of the key, calibration basis, budget warnings and server-side blocks for any AI cost estimate.
export default function EstimateNotes({ est, testid = "estimate" }) {
  if (!est) return null;
  return (
    <div className="space-y-1" data-testid={`${testid}-notes`}>
      <p className="flex items-start gap-1 text-[10.5px] leading-snug text-slate-500" data-testid={`${testid}-source`}>
        <KeyRound size={11} className="mt-px shrink-0" />
        <span>{est.source_label}{est.model ? ` · ${est.model}` : ""}{est.calibration ? ` · ${calibrationText(est.calibration)}` : ""}</span>
      </p>
      <BudgetWarning budget={est.budget} testid={`${testid}-budget-warning`} />
      {est.blocked && (
        <p className="flex items-start gap-1 text-[11px] leading-snug text-red-600" data-testid={`${testid}-blocked`}>
          <Ban size={12} className="mt-px shrink-0" />{est.blocked_message}
        </p>
      )}
    </div>
  );
}
